module.exports = __webpack_public_path__ + "img/youtube.7d9a5495.svg";